"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useRef, useEffect, useContext, useEffectEvent, useMemo } from "react";
import UnifiedWavesListWaves, { UnifiedWavesListWavesHandle } from "../left-sidebar/waves/UnifiedWavesListWaves";
import { UnifiedWavesListLoader } from "../left-sidebar/waves/UnifiedWavesListLoader";
import UnifiedWavesListEmpty from "../left-sidebar/waves/UnifiedWavesListEmpty";
import BrainLeftSidebarCreateADirectMessageButton from "../left-sidebar/BrainLeftSidebarCreateADirectMessageButton";
import { useMyStream } from "@/contexts/wave/MyStreamContext";
import { AuthContext } from "@/components/auth/Auth";
import { useSeizeConnectContext } from "@/components/auth/SeizeConnectContext";
import UserSetUpProfileCta from "@/components/user/utils/set-up-profile/UserSetUpProfileCta";
import useDeviceInfo from "@/hooks/useDeviceInfo";
import ConnectWallet from "@/components/common/ConnectWallet";
import Image from "next/image";
interface DirectMessagesListProps {
  readonly scrollContainerRef: React.RefObject<HTMLDivElement | null>;
}
const DirectMessagesList: React.FC<DirectMessagesListProps> = t0 => {
  const $ = _c(39);
  const {
    scrollContainerRef
  } = t0;
  const {
    isAuthenticated
  } = useSeizeConnectContext();
  const {
    connectedProfile
  } = useContext(AuthContext);
  const {
    isApp
  } = useDeviceInfo();
  const listRef = useRef(null);
  const hasFetchedRef = useRef(false);
  const {
    directMessages,
    registerWave
  } = useMyStream();
  const {
    list,
    hasNextPage,
    isFetchingNextPage,
    isFetching,
    fetchNextPage
  } = directMessages;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      hasFetchedRef.current = false;
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== hasNextPage || $[2] !== isFetchingNextPage) {
    t2 = [hasNextPage, isFetchingNextPage];
    $[1] = hasNextPage;
    $[2] = isFetchingNextPage;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] !== fetchNextPage || $[5] !== hasNextPage || $[6] !== isFetchingNextPage) {
    t3 = () => {
      if (!hasNextPage || isFetchingNextPage || hasFetchedRef.current) {
        return;
      }
      hasFetchedRef.current = true;
      fetchNextPage();
    };
    $[4] = fetchNextPage;
    $[5] = hasNextPage;
    $[6] = isFetchingNextPage;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const fetchNextPageIfNeeded = useEffectEvent(t3);
  let t4;
  if ($[8] !== fetchNextPageIfNeeded || $[9] !== hasNextPage || $[10] !== isFetchingNextPage) {
    t4 = () => {
      const listHandle = listRef.current;
      const sentinel = listHandle?.sentinelRef.current;
      if (!sentinel || !hasNextPage || isFetchingNextPage) {
        return;
      }
      const observer = new IntersectionObserver(t5 => {
        const [entry] = t5;
        if (entry.isIntersecting) {
          fetchNextPageIfNeeded();
        }
      }, {
        root: listHandle?.containerRef.current,
        rootMargin: "100px"
      });
      observer.observe(sentinel);
      return () => observer.disconnect();
    };
    $[8] = fetchNextPageIfNeeded;
    $[9] = hasNextPage;
    $[10] = isFetchingNextPage;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = list.length > 0;
  let t6;
  if ($[12] !== hasNextPage || $[13] !== isFetchingNextPage || $[14] !== t5) {
    t6 = [hasNextPage, isFetchingNextPage, t5];
    $[12] = hasNextPage;
    $[13] = isFetchingNextPage;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  useEffect(t4, t6);
  const shouldShowPlaceholder = !isAuthenticated || !connectedProfile?.handle;
  let t7;
  if ($[16] !== list) {
    t7 = list.map(_temp);
    $[16] = list;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const wavesWithPinned = t7;
  if (shouldShowPlaceholder) {
    if (!isAuthenticated) {
      let t8;
      if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
        t8 = <ConnectWallet />;
        $[18] = t8;
      } else {
        t8 = $[18];
      }
      return t8;
    }
    let t8;
    if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <><h1 className="tw-text-xl tw-font-bold">You need to set up a profile to continue.</h1><UserSetUpProfileCta /></>;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    const placeholderContent = t8;
    let t9;
    if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <div id="my-stream-connect" className="tw-flex tw-flex-col md:tw-flex-row tw-items-center tw-justify-center tw-gap-8 tw-h-full tw-p-6 tailwind-scope"><Image unoptimized={true} priority={true} loading="eager" src="https://d3lqz0a4bldqgf.cloudfront.net/images/scaled_x450/0x33FD426905F149f8376e227d0C9D3340AaD17aF1/279.WEBP" alt="Brain" width={304} height={450} className="tw-rounded-md tw-shadow-lg tw-max-w-[30vw] md:tw-max-w-[200px] tw-h-auto" /><div className="tw-flex tw-flex-col tw-items-center md:tw-items-start tw-text-center md:tw-text-left tw-gap-4">{placeholderContent}</div></div>;
      $[20] = t9;
    } else {
      t9 = $[20];
    }
    return t9;
  }
  let t8;
  if ($[21] !== isApp) {
    t8 = !isApp && <div className="tw-px-4 tw-mb-4"><BrainLeftSidebarCreateADirectMessageButton /></div>;
    $[21] = isApp;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== registerWave || $[24] !== scrollContainerRef || $[25] !== wavesWithPinned) {
    t9 = <UnifiedWavesListWaves ref={listRef} waves={wavesWithPinned} onHover={registerWave} hideToggle={true} hidePin={true} hideHeaders={true} scrollContainerRef={scrollContainerRef} />;
    $[23] = registerWave;
    $[24] = scrollContainerRef;
    $[25] = wavesWithPinned;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  const t10 = isFetching && list.length === 0;
  let t11;
  if ($[27] !== isFetchingNextPage || $[28] !== t10) {
    t11 = <UnifiedWavesListLoader isFetching={t10} isFetchingNextPage={isFetchingNextPage} />;
    $[27] = isFetchingNextPage;
    $[28] = t10;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== isFetching || $[31] !== isFetchingNextPage || $[32] !== list) {
    t12 = <UnifiedWavesListEmpty sortedWaves={list} isFetching={isFetching} isFetchingNextPage={isFetchingNextPage} emptyMessage="No messages to display" />;
    $[30] = isFetching;
    $[31] = isFetchingNextPage;
    $[32] = list;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  let t13;
  if ($[34] !== t11 || $[35] !== t12 || $[36] !== t8 || $[37] !== t9) {
    t13 = <div className="tw-mb-4"><div className="tw-h-full tw-bg-iron-950 tw-rounded-xl tw-ring-1 tw-ring-inset tw-ring-iron-800 tw-py-4">{t8}{t9}{t11}{t12}</div></div>;
    $[34] = t11;
    $[35] = t12;
    $[36] = t8;
    $[37] = t9;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  return t13;
};
export default DirectMessagesList;
function _temp(w) {
  return {
    ...w,
    isPinned: false
  };
}